'use strict';
export const SETTINGS_MENU_STATES = {
    NONE: 'NONE',
    SPEED: 'SPEED',
    LAYOUTS: 'LAYOUTS',
};
